import { Input, Button, Spin } from 'antd'
import { AppConstant } from 'AppConstant'
import {
  Container,
  LoginBox,
  LoginDetails,
  Logo,
  LogoWrapper,
  InputWrapper,
  Label,
  ErrorWrapper,
  ButtonWrapper,
  PageContainer,
  ProfilesWrapper,
  ProfileItem,
  LoadingText,
  BottomActions,
  ActionText,
  StyledInput,
  Wrapper,
} from './index.styled'

import { useDoctorLogin } from './useDoctorLogin'
import LogoBadgeOutlined from '../../../images/LogoBadgeOutlined.png'
import LogoutIcon from '../../../images/logout.svg'
import { persistor } from '../../../redux/store'
import { APIStatus } from '../../../redux/types'

export default function DoctorLoginScreen() {
  const {
    doctorList,
    doctorListStatus,
    doctorListError,

    selectedProfile,
    otp,
    otpError,
    otpSent,
    verifying,

    sendDoctorOtpStatus,
    verifyDoctorOtpStatus,

    setOtp,
    sendOtp,
    resendOtp,
    verifyOtp,
    selectProfile,
    navigate,
  } = useDoctorLogin()

  return (
    <PageContainer>
      {/* Top-left logo */}
      <Logo
        src={LogoBadgeOutlined}
        alt="Kiro logo"
        onClick={() => {
          persistor.purge()
          localStorage.clear()
          window.location.reload()
        }}
      />

      {/* ===============================================================
            1) PROFILE SELECTION
          ============================================================== */}
      {!otpSent && (
        <>
          {/* Logout button (top right) - always visible */}
          {/* <div
            onClick={() => {
              persistor.purge()
              localStorage.clear()
              window.location.reload()
            }}
            style={{
              background: 'transparent',
              position: 'fixed',
              top: 24,
              right: 32,
              color: '#007F7C',
              display: 'flex',
              alignItems: 'center',
              cursor: 'pointer',
            }}
          >
            <img src={LogoutIcon} style={{ marginRight: '8px' }} />
          </div> */}

          {/* Doctor list */}
          {doctorList && doctorList.length > 0 && (
            <ProfilesWrapper>
              {doctorList.map((p: any) => (
                <ProfileItem
                  key={p.id}
                  image={p.user.profilePic}
                  onClick={() => {
                    selectProfile(p)
                    sendOtp(p)
                  }}
                />
              ))}
            </ProfilesWrapper>
          )}

          {/* Loading state */}
          {/* {loadingDoctors && <LoadingText>Loading doctors...</LoadingText>} */}
          {doctorListStatus === APIStatus.pending && (
            <Wrapper>
              <Spin />
            </Wrapper>
          )}

          {/* Error fetching doctor list */}
          {/* {doctorListStatus === APIStatus.rejected && doctorListError && <ErrorWrapper>{doctorListError}</ErrorWrapper>} */}

          {/* Sending OTP status */}
          {/* {sendingOtp && <LoadingText>Sending passcode...</LoadingText>} */}

          {/* Sending OTP failed */}
          {/* {sendDoctorOtpStatus === APIStatus.rejected && <ErrorWrapper>{sendDoctorOtpStatus}</ErrorWrapper>} */}
        </>
      )}

      {/* ===============================================================
            2) OTP VERIFICATION
          ============================================================== */}
      {otpSent && selectedProfile && (
        <Container>
          <div
            onClick={() => {
              persistor.purge()
              localStorage.clear()
              window.location.reload()
            }}
            style={{
              background: 'transparent',
              position: 'fixed',
              top: 24,
              right: 32,
              color: '#007F7C',
              display: 'flex',
              alignItems: 'center',
              cursor: 'pointer',
            }}
          >
            <img src={LogoutIcon} style={{ marginRight: '8px' }} />
          </div>

          <LoginBox>
            <LoginDetails
              onKeyDown={(e) => {
                if (e.key === 'Enter') verifyOtp()
              }}
            >
              <InputWrapper style={{ marginTop: '28px' }}>
                <Label>Verification Code</Label>

                <StyledInput
                  value={otp}
                  onChange={(e) => setOtp(e.target.value)}
                  autoFocus={true}
                  inputMode="numeric"
                  placeholder="Enter Code"
                />

                {/* OTP error */}
                {otpError && <ErrorWrapper>{otpError}</ErrorWrapper>}

                <ButtonWrapper>
                  <Button type="primary" style={{ width: '100%' }} loading={verifying} onClick={verifyOtp}>
                    Verify
                  </Button>
                </ButtonWrapper>

                {/* Actions */}
                <BottomActions>
                  <ActionText onClick={resendOtp} style={{ opacity: verifying ? 0.7 : 1 }}>
                    Resend OTP
                  </ActionText>

                  {/* <ActionText onClick={() => window.location.reload()}>Choose Another Profile</ActionText> */}
                </BottomActions>
              </InputWrapper>
            </LoginDetails>
          </LoginBox>
        </Container>
      )}
    </PageContainer>
  )
}
